import { EApplications } from 'core/model/enums/channel.enum';
import type { IPlatformItem } from 'shared/components/platform-selector/platform-selector';

export const PLATFORMS: Array<IPlatformItem> = [
  { id: EApplications.GENERAL, label: 'Generales', icon: 'globe' },
  { id: EApplications.WEB, label: 'Web', icon: 'laptop' },
  { id: EApplications.APP, label: 'App', icon: 'mobile-vertical' },
];

export const FILTERS_CODE_SEPARATOR = '-' as const;

export const ITEMS_PER_PAGE = 10;

export const DEFAULT_PAGE = 1;

export const DEFAULT_TOTAL_PAGES = 1;
